<template lang="">
  <div class="bbs_write">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        
        <tr>
          <th scope="row">제목</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="제목을 입력하세요." v-model="title">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">기간</th>
          <td>
            <div class="item">
              <div class="ui_period">
                <span class="bbs_datepicker"><input type="date" id="datepicker_start" v-model="startDate"></span> 
                <span class="char">~</span>
                <span class="bbs_datepicker"><input type="date" id="datepicker_end" v-model="endDate"></span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">상태</th>
          <td>
            <div class="item">
              <span class="ui_chkbox primary lgray" style="width:70px">
                <input type="radio" name="sort" value="y" v-model="useStatus" checked>
                <label for="">
                  <span class="txt">사용</span>
                </label>
              </span>
              <span class="ui_chkbox primary lgray">
                <input type="radio" name="sort" value="n" v-model="useStatus">
                <label for="">
                  <span class="txt">미사용</span>
                </label>
              </span>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">위치</th>
          <td>
            <div class="item">
              <div class="pos">
                <label for="" class="">X 좌표:</label>
                <input type="number" class="i_txt lineless ml10" placeholder="좌표를 입력해 주세요." style="width:145px" v-model="xCoord">

                <label for="">Y 좌표:</label>
                <input type="number" class="i_txt lineless" placeholder="좌표를 입력해 주세요." style="width:145px" v-model="yCoord">
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">내용</th>
          <td>
            <div class="item">
              <textarea name="" id="" cols="30" rows="10" class="i_ta type_full lineless" placeholder="상세 내용을 입력하세요." v-model="content"></textarea>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div><!-- //BBS : WRITE -->

  <!-- BBS : CONTROLLER -->
  <div class="bbs_controller">
    <div class="lft_area">
      <a href="#none" class="bt_base gray large_h btn_list" @click="toList">목록</a>
    </div>

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="savePopup">{{ popupSeq ? '수정' : '저장' }}</button>
      <button type="reset" class="bt_base gray large_h" v-if="popupSeq" @click="deletePopup">삭제</button>
    </div>
  </div><!-- //BBS : CONTROLLER -->
</template>
<script>
import { mapActions, mapState } from 'vuex';
const adminPopupModule = 'adminPopupModule'

export default {
  data (){
    return {
      popupSeq: this.$route.query.popupSeq,
      title: '',
      content: '',
      startDate: '',
      endDate: '',
      useStatus: 'y',
      xCoord: 0,
      yCoord: 0,
    }
  },
  methods: {
    ...mapActions(adminPopupModule, [
      'requestSavePopup',
      'requestPopup',
      'requestDeletePopups'
    ]),

    toList () {
      this.$router.push({ name: "PopupManageListPage" })
    },

    async savePopup() {
      const { popupSeq, title, content, startDate, endDate, useStatus, xCoord, yCoord } = this

      const result = await this.requestSavePopup({ popupSeq, title, content, startDate, endDate, useStatus, xCoord, yCoord })
      if (result) {
        this.$router.push({ name: "PopupManageListPage" })
      }
    },

    async deletePopup () {
      if (confirm("팝업을 삭제하시겠습니까?")) {
        let deleteList = []
        deleteList.push(this.popupSeq)
        if (await this.requestDeletePopups(deleteList)) {
          alert("삭제가 완료됐습니다")
          this.$router.push({ name: 'PopupManageListPage' })
        }
      }
    }
  },

  computed: {
    ...mapState(adminPopupModule, ['popup'])
  },

  async mounted() {
    if (this.$route.query.popupSeq) {
      await this.requestPopup(this.$route.query.popupSeq);

      this.title = this.popup.title;
      this.content = this.popup.content;
      this.useStatus = this.popup.useStatus;
      this.startDate = this.popup.startDate;
      this.endDate = this.popup.endDate;
      this.xCoord = this.popup.xcoord;
      this.yCoord = this.popup.ycoord;
    }
  }
}
</script>
<style lang="">
    
</style>